// @flow
import React, { memo } from 'react'
import CookieIcon from '@website/common/assets/svgr-icons/cookie.svg'

import { reopenCookieBanner, useCanReopenBanner } from '../reopen'

import * as Styled from './styled'
import { ARIA_LABEL } from './consts'
import type { TReopenButtonProps } from './types'

const ReopenButton = ({ isShifted }: TReopenButtonProps) => {
  const canReopen = useCanReopenBanner()

  if (!canReopen) {
    return null
  }

  return (
    <Styled.Button
      type="button"
      isShifted={isShifted}
      aria-label={ARIA_LABEL}
      onClick={reopenCookieBanner}
    >
      <CookieIcon />
    </Styled.Button>
  )
}

export default memo(ReopenButton)
